import { RobotOutlined } from '@ant-design/icons';
import { Card, Radio, RadioChangeEvent } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { useTypedSelector } from '../../../store';
import { impExternalShouldAutoAssignUpdated } from '../../../store/impExternal';
import { ocrShouldAutoAssignUpdated } from '../../../store/impOcr';
import { GRID_LG } from '../../../styles';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import { Button2Lines } from '../../Subscribe/SubscribeActions';
import { ImpTypes, IMP_OCR } from './impCommonData';

const ImpCommAutoAssign = ({ impType }:{ impType: ImpTypes }) => {

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const { width } = useWindowSize();

  const shouldAutoAssign = useTypedSelector(state =>
    impType === IMP_OCR ?
      state.impOcr.shouldAutoAssign : state.impExternal.shouldAutoAssign);

  const onChange = (e: RadioChangeEvent) => {
    if (impType === IMP_OCR) {
      dispatch(ocrShouldAutoAssignUpdated(e.target.value));
    } else {
      dispatch(impExternalShouldAutoAssignUpdated(e.target.value));
    }
  };

  return (
    <Card
      type="inner"
      title={t('ImpCommAutoAssign.title')}
      extra={(
        <>
          <RobotOutlined />
          {' '}
          <strong>AI</strong>
        </>
)}
    >
      { width >= GRID_LG ? (
        <Radio.Group
          onChange={onChange}
          value={shouldAutoAssign}
        >
          <Radio style={radioStyle} value={false}>
            <strong>
              {' '}
              {t('ImpCommAutoAssign.desc')}
              {' '}
            </strong>
            {' '}
            {t('ImpCommAutoAssign.desc2')}
          </Radio>
          <Radio style={radioStyle} value={true}>
            {t('ImpCommAutoAssign.desc3')}
            {' '}
            <strong>
              {' '}
              {t('ImpCommAutoAssign.desc4')}
              {' '}
            </strong>
            {' '}
            {t('ImpCommAutoAssign.desc5')}
          </Radio>
        </Radio.Group>
      ) : (
        <Radio.Group
          onChange={onChange}
          value={shouldAutoAssign}
          style={{ width: '100%' }}
        >
          <Button2Lines value={false}>
            <strong>
              {' '}
              {t('ImpCommAutoAssign.desc')}
            </strong>
            {' '}
            {t('ImpCommAutoAssign.des2')}
          </Button2Lines>
          <Button2Lines value={true}>
            {t('ImpCommAutoAssign.desc3')}
            {' '}
            <strong>
              {' '}
              {t('ImpCommAutoAssign.desc4')}
            </strong>
            {' '}
            {t('ImpCommAutoAssign.desc5')}
          </Button2Lines>
        </Radio.Group>
      )}
    </Card>

  );
};

export default ImpCommAutoAssign;

const radioStyle = {
  display: 'block',
  lineHeight: '24px',
};